// extracted by mini-css-extract-plugin
module.exports = {"Gift":"Gift_Gift__PJ60O"};